module.exports = __webpack_public_path__ + "static/img/view_bg.aeaf4baf.jpg";